import type { FileObject } from '@klp/file/classes';

export interface IGovernmentSupportMonth {
    monthNumber: string;
    month: string;
    caseNumber: string;
    supportSum: number;
}

export const governmentSupportMonths: Array<IGovernmentSupportMonth> = [
    { monthNumber: '03', month: 'Mars', caseNumber: '', supportSum: 0 },
    { monthNumber: '04', month: 'April', caseNumber: '', supportSum: 0 },
    { monthNumber: '05', month: 'Mai', caseNumber: '', supportSum: 0 },
    { monthNumber: '06', month: 'Juni', caseNumber: '', supportSum: 0 },
];

export interface IRevenueMonth {
    monthNumber: string;
    month: string;
    revenue2019: number;
    revenue2020: number;
}

export const revenueMonths: Array<IRevenueMonth> = [
    { monthNumber: '03', month: 'Mars', revenue2019: 0, revenue2020: 0 },
    { monthNumber: '04', month: 'April', revenue2019: 0, revenue2020: 0 },
    { monthNumber: '05', month: 'Mai', revenue2019: 0, revenue2020: 0 },
    { monthNumber: '06', month: 'Juni', revenue2019: 0, revenue2020: 0 },
];

export interface IKLPSupportForm {
    id: string | number;
    companyName: string;
    email: string;
    hasGovernmentSupport: boolean;
    governmentSupportAmount202003: number;
    governmentSupportAmount202004: number;
    governmentSupportAmount202005: number;
    governmentSupportAmount202006: number;
    governmentSupportCaseNumber202003: string;
    governmentSupportCaseNumber202004: string;
    governmentSupportCaseNumber202005: string;
    governmentSupportCaseNumber202006: string;
    governmentSupportExplanation: string;
    invoiceNumber: string;
    klpSupportReason: string;
    kundeNummer: string;
    orgNumber: string;
    personApplying: string;
    phoneNumber: string;
    revenue201903: number;
    revenue201904: number;
    revenue201905: number;
    revenue201906: number;
    revenue202003: number;
    revenue202004: number;
    revenue202005: number;
    revenue202006: number;
    shoppingCenter: string;
    storeName: string;
    supportFormFiles: Array<FileObject> | object;
    [key: string]: any;
}

export const shoppingCenters = [
    'Fornebu',
    'Byporten',
    'Paleet',
    'Glassmagasinet',
    'Hvaltorvet',
];

export class KLPSupportForm implements IKLPSupportForm {
    public static empty() {
        return new KLPSupportForm({
            id: '',
            companyName: '',
            email: '',
            hasGovernmentSupport: false,
            governmentSupportAmount202003: 0,
            governmentSupportAmount202004: 0,
            governmentSupportAmount202005: 0,
            governmentSupportAmount202006: 0,
            governmentSupportCaseNumber202003: '',
            governmentSupportCaseNumber202004: '',
            governmentSupportCaseNumber202005: '',
            governmentSupportCaseNumber202006: '',
            governmentSupportExplanation: '',
            invoiceNumber: '',
            klpSupportReason: '',
            kundeNummer: '',
            orgNumber: '',
            personApplying: '',
            phoneNumber: '',
            revenue201903: 0,
            revenue201904: 0,
            revenue201905: 0,
            revenue201906: 0,
            revenue202003: 0,
            revenue202004: 0,
            revenue202005: 0,
            revenue202006: 0,
            shoppingCenter: '',
            storeName: '',
            supportFormFiles: [],
        });
    }

    public static parseObject(obj: IKLPSupportForm): KLPSupportForm {
        try {
            return new KLPSupportForm(obj);
        } catch (e) {
            throw new Error(
                `Couldn't parse object: ${JSON.stringify(obj)} ${e}`,
            );
        }
    }

    public id: string | number;
    public companyName: string;
    public email: string;
    public hasGovernmentSupport: boolean;
    public governmentSupportAmount202003: number;
    public governmentSupportAmount202004: number;
    public governmentSupportAmount202005: number;
    public governmentSupportAmount202006: number;
    public governmentSupportCaseNumber202003: string;
    public governmentSupportCaseNumber202004: string;
    public governmentSupportCaseNumber202005: string;
    public governmentSupportCaseNumber202006: string;
    public governmentSupportExplanation: string;
    public invoiceNumber: string;
    public klpSupportReason: string;
    public kundeNummer: string;
    public orgNumber: string;
    public personApplying: string;
    public phoneNumber: string;
    public revenue201903: number;
    public revenue201904: number;
    public revenue201905: number;
    public revenue201906: number;
    public revenue202003: number;
    public revenue202004: number;
    public revenue202005: number;
    public revenue202006: number;
    public shoppingCenter: string;
    public storeName: string;
    public supportFormFiles: Array<FileObject> | object;

    constructor(params: IKLPSupportForm) {
        const { supportFormFiles } = params;
        if (supportFormFiles) {
            params.supportFormFiles = Array.from(
                Object.values(supportFormFiles),
            );
        } else {
            params.supportFormFiles = [];
        }

        params.id = `${params.kundeNummer}-${params.email}`;

        Object.assign(this, params);
    }
}
